export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjNmMDg5MTYwLTVjYTgtNDA4Yy05OTk5LTljNTVkMjIyYjliYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.sq4hVFw7OQzwzjh+R2Kdf58QrLb1uUxeQA60NVX68AYkqHsycvyMox1gCqkXEsAcB0LviDvpyIRO5X6hkt0K4mC4va4qzlrabswUW2dZ9t7GEvfL9QBppT8sN4JYkFtrF/Awhw==';
